import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
	state: {
		plans: [],
		vanityAddress: [],
		postcode: '',
		isWasteServiceable: '',
		isGasServiceable: '',
		isElectricityServiceable: '',
		isSkipServiceable: '',
		isSkipBagServiceable: '',
		domesticPriceGroup: '',
		origin: window.location.origin,
	}, mutations: {
		updateValue(state, {property, value}) {
			state[`${property}`] = value;
		}, setPlans(state, plans) {

			state.plans = plans;
		},
	}, actions: {
		getPlans({commit, state}) {

			axios.get(`${state.origin}/wp-json/wp/v2/signup_plans`).
				then(response => {
					commit('setPlans',
						response.data)
				})
		},
	}, modules: {},
})
